/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import Options from './Options';

/**
* The ResponseOptions model module.
* @module model/ResponseOptions
* @version 2020-12-7
*/
export default class ResponseOptions {
    /**
    * Constructs a new <code>ResponseOptions</code>.
    * @alias module:model/ResponseOptions
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>ResponseOptions</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/ResponseOptions} obj Optional instance to populate.
    * @return {module:model/ResponseOptions} The populated <code>ResponseOptions</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ResponseOptions();
                        
            
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;




}
